
<script setup>
import LoginForm from '@/components/LoginForm.vue'
</script>

<template>
  <div>
    <login-form />
  </div>
</template>
